// import { useLanguage } from '../../Context/Language';
import { useState } from 'react';
import { Link } from 'react-router-dom'
import './Home.css'

import Tool from '../../Components/Tool/Tool'
import Skill from '../../Components/Skill/Skill'
import Separator from '../../Components/Separator/Separator'
import SEO from '../../Components/SEO/SEO'
import PageTitle from '../../Hooks/PageTitle'

import professional_yassine from '../../Media/Home.Media/Personal.Media/professional_yassine.png'
import renaissance_yassine from '../../Media/Home.Media/Personal.Media/renaissance_yassine.png'
import yassine_rub from '../../Media/Home.Media/Personal.Media/yassine_rub.jpg'
import yassine_bochum from '../../Media/Home.Media/Personal.Media/yassine_bochum.jpg'
import yassine_bell from '../../Media/Home.Media/Personal.Media/yassine_bell.jpg'
import yassine_lib from '../../Media/Home.Media/Personal.Media/yassine_lib.jpeg'
import normal_yassine from '../../Media/Home.Media/Personal.Media/normal_yassine.jpg'
import cool_yassine from '../../Media/Home.Media/Personal.Media/cool_yassine.jpg'
import nerdy_yassine from '../../Media/Home.Media/Personal.Media/nerdy_yassine.png'
import glorious_speech2 from '../../Media/Home.Media/Personal.Media/glorious_speech2.mp4'
import glorious_speech from '../../Media/Home.Media/Personal.Media/glorious_speech.mp4'

import python from '../../Media/Home.Media/Tools.Media/python.png'
import node from '../../Media/Home.Media/Tools.Media/node-js.png'
import react from '../../Media/Home.Media/Tools.Media/react.png'
import html from '../../Media/Home.Media/Tools.Media/html-5.png'
import css from '../../Media/Home.Media/Tools.Media/css-3.png'
import js from '../../Media/Home.Media/Tools.Media/js.png'
import c from '../../Media/Home.Media/Tools.Media/c.png'
import raspberry from '../../Media/Home.Media/Tools.Media/raspberry-pi.png'
import arduino from '../../Media/Home.Media/Tools.Media/arduino.png'
import tinker from '../../Media/Home.Media/Tools.Media/tinker-cad.png'
import uml from '../../Media/Home.Media/Tools.Media/uml.png'
import git from '../../Media/Home.Media/Tools.Media/git.png'
import message from '../../Media/Home.Media/message.png'

import machine_learning from '../../Media/Home.Media/Skills.Media/machine_learning.png'
import robotics from '../../Media/Home.Media/Skills.Media/robotics.png'
import iot from '../../Media/Home.Media/Skills.Media/iot.png'
import web_dev from '../../Media/Home.Media/Skills.Media/web_dev.png'
import browser_extension from '../../Media/Home.Media/Skills.Media/browser_extension.png'
import web_scraping from '../../Media/Home.Media/Skills.Media/web_scraping.png'
import database from '../../Media/Home.Media/Skills.Media/database.png'
import data_visualisation from '../../Media/Home.Media/Skills.Media/data_visualisation.png'

const jjk_quotes = [
    'Deadlines could cause me troubles, but would I lose? Nah, I\'d win.',
    'Throughout heaven and earth, I alone am the honored one.',
];

// const domain_expansions = [
//     'Malevolent Portfolio',
//     'Unlimited Engineering',
//     'Garden of Achievements',
//     'Cursed Gradients',
//     'Infinite Backpropagation',
// ]; 
const jjk_reference = jjk_quotes[Math.floor(Math.random() * jjk_quotes.length)]
// const domain_expansions_reference = domain_expansions[Math.floor(Math.random() * domain_expansions.length)]

const Home = () => {
    PageTitle('Home');
    // const { t } = useLanguage();
    // const content = t.home; 

    const testimonials = [
        // testos from recommendation letters
        // [
        //     'Tarik Taleb', 
        //     'https://www.linkedin.com/in/tariktaleb/', 
        //     'Chair Professor at Ruhr University Bochum', 
        //     'Internship Supervisor',
        //     ''
        // ],
        [
            'Hajar Mousannif',
            'https://mousannifhajar.com/',
            "Professor, Coordinator of the Master's Program in Artificial Intelligence, Faculty of Sciences Semlalia, Cadi Ayyad University",
            'My Professor, Projects Supervisor & Master Coordinator',
            `One thing that has stood out across his time in the program is how well Yassine bridges theory 
            and implementation. He is comfortable with the conceptual side of AI, but just as capable when 
            a project calls for solid engineering: writing production-quality code, integrating hardware, 
            or getting a system to actually run outside a notebook. This range is uncommon at the Master's 
            level, where most students specialize heavily in one direction or the other.`,
            'Excerpt from official recommendation letter'
        ],
        [
            'Mariya Ouaissa',
            'https://www.linkedin.com/in/mariyaouaissa/',
            'Professor of Networks, Cybersecurity and Artificial Intelligence, Faculty of Sciences Semlalia, Cadi Ayyad University',
            'My Professor & Bachelor Final Studies Project Supervisor',
            `Yassine has consistently demonstrated strong intellectual curiosity, analytical thinking, and a
            commitment to excellence. In my courses and projects related to Cybersecurity and Artificial
            Intelligence, he distinguished himself through his ability to understand complex concepts,
            analyze challenging problems, and apply his knowledge effectively.`,
            'Excerpt from official recommendation letter'
        ],
        [
            'Mohamed-Amine Chadi',
            'https://www.linkedin.com/in/mohamed-amine-chadi-179baa115/',
            'Professor of computer science and AI, faculty of sciences Semlalia, Cadi Ayyad University',
            'My Professor, Research & Projects Supervisor',
            `What distinguishes Yassine most is a combination of skills that is genuinely rare among AI 
            students: alongside his AI-related skills, Yassine possesses excellent hands-on technical 
            abilities across programming, software development, and application building, as well as 
            robotics, networking, and embedded systems. This breadth allows him to move fluidly between 
            designing intelligent models and building the systems that put them into practice, a 
            combination that few students manage to develop.`,
            'Excerpt from official recommendation letter'
        ],
        [
            'Said Wahid', 
            'https://www.linkedin.com/in/said-wahid-a0927715/', 
            'MVP, MCT Microsoft Ingénieur Microsoft chez CEGID Ingénieur Logiciel', 
            'My Internship Supervisor',
            `Yassine a fait preuve d'un sérieux remarquable durant son stage. Travailleur, autonome 
            et extrêmement impliqué, il a su être rapidement productif et a apporté une réelle valeur 
            à nos projets. Sa capacité à apprendre vite, à proposer des solutions pertinentes et à 
            livrer un travail de qualité en fait un collaborateur sur qui l'on peut compter. Je recommande 
            vivement Yassine pour son professionnalisme et son engagement.`
        ],
        [
            'Ali Aithoussa', 
            'https://www.linkedin.com/in/ali-h-448289116/', 
            'Data science master student at the faculty of sciences and technology', 
            'My Freelance Collaborator',
            `Hardest working fellas out there (especially if it matters to him). Best co worker
            will recommand in every porject. May his spirit and drive live forevermore.`
        ],
        [
            'Zahra Abouhane', 
            'https://www.linkedin.com/in/zahra-abouhane-27b8b218a/', 
            'Artificial intelligence master student at the faculty of sciences Semlalia', 
            'My Colleague & Projects Collaborator',
            `Yassine Bazgour Un très bon collaborateur de projets, travailleur, sérieux et rigoureux 
            au sens des tâches qui doivent etre réalisées en termes d'efficacité et de perfection, il 
            maitraise son travail et le fait jusqu'au bout de la bonne manière. Et quand on parle de la 
            créativité c'est une autre histoire pour un tel artiste comme lui ! Tout simplement c'est la 
            meilleure personne que quelqu'un peut choisir pour son projet !`
        ],
    ];

    const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
    const handlePrevious = () => {
        setCurrentTestimonialIndex((prevIndex) =>
            prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
        );
    };
    const handleNext = () => {
        setCurrentTestimonialIndex((prevIndex) =>
            prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
        );
    };

    const images = [
        professional_yassine,
        renaissance_yassine,
        normal_yassine, 
        cool_yassine, 
        nerdy_yassine,
        yassine_rub,
        yassine_bochum,
        yassine_bell,
        yassine_lib,
    ];
    const videos = [
        glorious_speech, 
        glorious_speech2
    ];

    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
    const [showVideo, setShowVideo] = useState(false);

    const handleImageSwitch = () => {
        if (!showVideo) {
            if (currentImageIndex < images.length - 1) {
                setCurrentImageIndex(prev => prev + 1);
            } else {
                setShowVideo(true);
                setCurrentVideoIndex(0);
            }
        } else {
            if (currentVideoIndex < videos.length - 1) {
                setCurrentVideoIndex(prev => prev + 1);
            } else {
                setShowVideo(false);
                setCurrentImageIndex(0);
            }
        }
    };

    const currentImage = images[currentImageIndex];
    const currentVideo = videos[currentVideoIndex];

    return (
        <>  
            <SEO 
                title="Yassine Bazgour"
                description="AI Alchemist and Web Sorcerer. AI and Data Science student specializing in machine learning, deep learning, computer vision, NLP, and full-stack web development. Building intelligent systems that solve real-world problems. Based in Marrakech, Morocco."
                url="https://yassinebazgour.vercel.app"
                keywords="Yassine Bazgour, AI Engineer, Machine Learning Engineer, Full Stack Developer, Deep Learning, Computer Vision, NLP, Python Developer, React Developer, Morocco AI, Marrakech Developer, Artificial Intelligence Portfolio"
            />
            <div className='home-header'>
                <div className='home-header-text-content'>
                    <span className='home-header-welcome'><span className='hand-emoji'>👋</span> Hi, Welcome Dear! I am Yassine Bazgour.</span>
                    <span className='home-header-into'>AI Alchemist And Web Sorcerer</span>
                    <span className='home-header-description-part'>
                        AI and Data Science student who talks to machines more than people.
                        I build stuff that thinks, moves, and occasionally predicts the future, from smart stethoscopes to stupid dermatologists.
                        <br/>A wise man once said: "If it's not solving a real-world problem, it's a piece of shit ✨."
                    </span>
                    <span className='home-header-description-part'>
                        Based in Morocco, recently finished Background in Mathematics and Computer Science, currently immersed in 
                        Artificial Intelligence research and development. Most days I'm fine-tuning models, experimenting 
                        with new architectures, and running on way too much coffee.
                    </span>
                    <span className='home-header-description-part'>
                        {jjk_reference}
                        {/* <br/>Domain expansion: {domain_expansions_reference} */}
                    </span>
                    <div className='home-header-buttons-container'>
                        <Link 
                            to='/Contact'
                            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                        >
                            <button className='home-header-button get-in-touch'>GET IN TOUCH</button>
                        </Link>
                        <button 
                            onClick={() => {window.open('https://drive.google.com/file/d/1pC2vYo9KjBXQzzKBIqBoIqE0rSEYJgE3/view?usp=sharing', '_blank')}} 
                            className='home-header-button learn-more'
                        >
                            View My Resume
                        </button>
                    </div>
                </div>
                <div className='home-header-image-container'>
                    {showVideo ? (
                        <video
                            className='home-header-image'
                            src={currentVideo}
                            autoPlay
                        />
                    ) : (
                        <img className='home-header-image' src={currentImage} alt='Worthy opponent'/>
                    )}
                    <i
                        className='switch-icon fa fa-rotate'
                        onClick={handleImageSwitch}
                    ></i>
                </div>
            </div>
            <Separator/>
            <div className='tech-tools-container'>
                <div className='tech-tools-text-content'>
                    <span className='tech-tools-title'>Tech Stack</span>
                    <span className='tech-tools-description'>A list of my favorite tools and technologies that I use on a regular basis.</span>
                </div>
                <div className='tech-tools-rows-container'>
                    <Tool image={python} title='Python' usecase='Machine Learning' color="rgb(45, 70, 90)"/>
                    <Tool image={react} title='React' usecase='Web Development' color="rgb(40, 80, 95)"/>
                    <Tool image={node} title='Node.js' usecase='Web Development' color="rgb(43, 90, 50)"/>
                    <Tool image={html} title='HTML' usecase='Web Development' color="rgb(134, 67, 67)"/>
                    <Tool image={css} title='CSS' usecase='Web Development' color="rgb(32, 57, 101)"/>
                    <Tool image={js} title='JavaScript' usecase='Web Development' color="rgb(81, 75, 20)"/>
                    <Tool image={raspberry} title='Raspberry Pi' usecase='Embedded Systems' color="rgb(95, 40, 55)"/>
                    <Tool image={arduino} title='Arduino' usecase='Embedded Systems' color="rgb(45, 90, 90)"/>
                    <Tool image={c} title='C/C++' usecase='Embedded Systems' color="rgb(40, 65, 105)"/>
                    <Tool image={git} title='Git' usecase='Code Management' color="rgb(0, 0, 0)"/>
                    <Tool image={uml} title='UML' usecase='Software Architecture' color="rgb(181, 181, 181)"/>
                    <Tool image={tinker} title='Tinker Cad' usecase='Hardware Architecture' color="rgb(255, 255, 255)"/>
                </div>
            </div>
            <Separator/>
            <div className='about-skills'>
                <div className='skills-text-content'>
                    <span className='skills-title'>Skills</span>
                    <span className='skills-description'>
                        These are the key skills I've developed through my experience in computer science and more.<br/>
                        They reflect my ability to solve complex problems and build creative solutions.
                    </span>
                </div>
                <div className='skills-container'>
                    <Skill image={machine_learning} alt='Machine Learning' title='Machine Learning' description='Using data and algorithms, I develop predictive models that power decision-making and solve real-world problems.'/>
                    <Skill image={robotics} alt='Robotics' title='Robotics' description='Exploring the fascinating world of robotics, I combine embedded systems and AI to build smart, automated systems.'/>
                    <Skill image={web_dev} alt='Web Development' title='Web Development' description='I enjoy creating interactive and responsive web applications, focusing on intuitive user experiences and clean designs.'/>
                    <Skill image={iot} alt='Internet of Things' title='Internet of Things' description='I build IoT systems that integrate sensors, microcontrollers, and software to enhance everyday life and industries.'/>
                    <Skill image={browser_extension} alt='Browser Extensions' title='Browser Extensions' description='I build browser extensions that enhance user experiences by adding custom features to web browsers.'/>
                    <Skill image={web_scraping} alt='Web Scraping' title='Web Scraping' description='I build web scrapers that extract and organize online data, providing structured information for decision making.'/>
                    <Skill image={database} alt='Databases' title='Databases' description='I design, implement, and manage databases that store and retrieve data efficiently, ensuring data integrity.'/>
                    <Skill image={data_visualisation} alt='Data Visualisation' title='Data Visualisation' description='I create interactive charts and graphs that make data easier to interpret, helping organizations make informed decisions.'/>
                </div>
            </div>
            <Separator/>
            <div className="testimonials-container">
                <span className="testimonials-title">Testimonials</span>
                <div className="testimonials-sub-container">
                    <i className="arrow-icon fa fa-arrow-left" onClick={handlePrevious}></i>
                    <div className="testimonial">
                        <img className="quote-icon" src={message} alt="quote-icon"></img>
                        <span className="testimonial-content">{testimonials[currentTestimonialIndex][4]}</span>
                        <span className="testimonial-source">{testimonials[currentTestimonialIndex][5]}</span>
                        <span onClick={() => { window.open(testimonials[currentTestimonialIndex][1], '_blank') }} className="testimonial-owner">{testimonials[currentTestimonialIndex][0]}</span>
                        <span className="testimonial-owner-identity">{testimonials[currentTestimonialIndex][2]}</span>
                        <span className="testimonial-owner-relation">{testimonials[currentTestimonialIndex][3]}</span>
                        <div>
                            <i className="fa fa-dot"></i>
                        </div>
                    </div>
                    <i className="arrow-icon fa fa-arrow-right" onClick={handleNext}></i>
                </div>
                <div className="testimonial-dots">
                    {testimonials.map((_, index) => (
                        <span
                            key={index}
                            className={`testimonial-dot ${index === currentTestimonialIndex ? 'active' : ''}`}
                            onClick={() => setCurrentTestimonialIndex(index)}
                        />
                    ))}
                </div>
            </div>
        </>
    )
}

export default Home
